import { useState, useCallback } from 'react';

const STORAGE_KEY = 'hs_seen_tips';

function getSeenTips(): Set<string> {
  try {
    return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
  } catch {
    return new Set();
  }
}

function persistSeenTips(tips: Set<string>): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...tips]));
}

export function useHotStreakTips() {
  const [seen, setSeen] = useState(getSeenTips);

  const shouldShow = useCallback((tipId: string) => !seen.has(tipId), [seen]);

  const dismiss = useCallback((tipId: string) => {
    setSeen((prev) => {
      const next = new Set(prev);
      next.add(tipId);
      persistSeenTips(next);
      return next;
    });
  }, []);

  return { shouldShow, dismiss };
}
